import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'

const userAdminApi = createApi({
  reducerPath: 'userAdminApi',
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL ?? ''
  }),
  tagTypes: ['AdminUserList', 'AdminUser', 'UserPermissions', 'ManageableCatalogue'],
  endpoints: () => ({})
})

export default userAdminApi
